import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, MessageCircle, MapPin, Phone, Mail } from "lucide-react";
import { CONTACT, DISCLAIMER } from "../../data/site";

const QUICK = [
  { label: "Home", to: "/" },
  { label: "Loans", to: "/loans" },
  { label: "Credit Cards", to: "/credit-cards" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-conditions" },
  { label: "Contact Us", to: "/contact" },
];

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/" },
  { icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/${CONTACT.whatsapp}` },
];

export const Footer = () => {
  return (
    <footer className="border-t border-[#E4E4E7] bg-white" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl brand-gradient text-white font-bold">
                C
              </span>
              <span className="text-xl font-bold tracking-tight text-[#09090B]">CARDED</span>
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-500">
              Your trusted Loan Direct Selling Agent for Personal, Business, Home Loans, LAP,
              Working Capital and Credit Card assistance across leading Banks and NBFCs.
            </p>
            <div className="mt-6 space-y-3 text-sm text-zinc-600">
              <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-3 hover:text-[#6C2BD9]" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-[#6C2BD9]" /> {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-[#6C2BD9]" data-testid="footer-email">
                <Mail className="h-4 w-4 text-[#6C2BD9]" /> {CONTACT.email}
              </a>
              <p className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 text-[#6C2BD9]" /> {CONTACT.address}
              </p>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-zinc-500">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {QUICK.map((q) => (
                <li key={q.to}>
                  <Link
                    to={q.to}
                    className="text-sm text-zinc-600 transition-colors hover:text-[#6C2BD9]"
                    data-testid={`footer-link-${q.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
                  >
                    {q.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-zinc-500">Follow Us</h4>
            <div className="mt-5 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#E4E4E7] text-zinc-600 transition-colors hover:border-[#6C2BD9] hover:text-[#6C2BD9]"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                >
                  <s.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
            <p className="mt-6 text-xs leading-relaxed text-zinc-400">{DISCLAIMER}</p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-[#E4E4E7] pt-6 sm:flex-row">
          <p className="text-xs text-zinc-500">© 2026 CARDED. All Rights Reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-xs text-zinc-500 hover:text-[#6C2BD9]">Privacy Policy</Link>
            <Link to="/terms-conditions" className="text-xs text-zinc-500 hover:text-[#6C2BD9]">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
